import { CFOrgStatus } from "redux/Types";
import { getCFTypeList, makeRandomId } from "util/CommonFunc";

export default (user,selectedItems, items, runtime, trackSequence = null) => ( 
    {
        id: "",
        name: ``,
        // name: `Untitled Clearance`,
        // name: `Untitled Clearance ${moment().format("dddd hh:mm:ss A")}`,
        // name: `Untitled Clearance ${moment().format("dddd hh:mm:ss A")} [${
        //   this.props.user.id
        // }]`,
        genre: "",
        notes: "",
        deadline: null, 
        refNo: makeRandomId(),
        synopsis: "",
        createdBy: user.id,
        updatedBy: user.id,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        status: CFOrgStatus.INPROGRESS,
        tracksCount: 0,
        clearance: {
          props: [],
          tracks: selectedItems,
          tLookup: items,
          replacedTracks: {},
          ...(trackSequence?{trackSequence: trackSequence}:{}),
        },
        clearancestatus: "inprogress",
        messageid: null,
        master: false,
        programmeType:  runtime && runtime._config && runtime._config.CF_HEADER_FIELD_LIST ? runtime._config.CF_HEADER_FIELD_LIST.filter(f=>f.id === "programmeType")[0]?.defaultValue : null,
        clearanceFormType: null,
        // clearanceFormType: getCFTypeList()[0]?.value || null,
        producerType: runtime && runtime._config && runtime._config.CF_HEADER_FIELD_LIST ? runtime._config.CF_HEADER_FIELD_LIST.filter(f=>f.id === "producerType")[0]?.defaultValue : null,
        channel: "",
        channelName:"",
        productionCompany:runtime && runtime._config && runtime._config.CF_HEADER_FIELD_LIST ? runtime._config.CF_HEADER_FIELD_LIST.filter(f=>f.id === "productionCompany")[0]?.defaultValue : null,
        productionCompanyContact: null,
        seriesTitle:"",
        promotionId:"",
        promotionTitle:"",
        programmeTitle:"",
        episodeTitle:"",
        prodNumber:"",
        productionName:"",
        contractNumber:"",
        episodeName:"",
        episodeNumber:"",
        
        promoOneoffHeaderQ1:"",
        promoOneoffHeaderQ2:"",
        promoOneoffHeaderQ2Sub1:"",
        promoOneoffHeaderQ3: "",
        promoOneoffHeaderQ3Sub1: "",
        promoOneoffHeaderQ4: "",
        promoOneoffHeaderQ4Sub1: "",
        promoOneoffHeaderQ5: "",
        promoOneoffHeaderQ5Sub1: "",
        promoOneoffHeaderQ6: "",
        promoOneoffHeaderQ7: "",
        promoOneoffHeaderQ7Sub1: "",
        promoOneoffHeaderQ8: "",
        promoOneoffHeaderQ9: "",
        promoOneoffHeaderQ10: "",
        promoOneoffHeaderQ12: "",
        promoOneoffHeaderQ13: "",
        promoOneoffHeaderQ14: "",
        promoOneoffHeaderQ14Sub1: "",
        promoOneoffHeaderQ14Sub1Sub1: "",
        promoOneoffHeaderQ15: "",
        promoOneoffHeaderQ16: "",
        deliveryDate: "",
        txDates: [],
        programmingHeaderQ1: "",
        programmingHeaderQ2: "",
        programmingHeaderQ3: "",
        programmingHeaderQ4: "",
        programmingHeaderQ5: "",
        programmingHeaderQ6: "",
        programmingHeaderQ7: "",
        programmingHeaderQ8: "",
        programmingHeaderQ9: "",
        programmingHeaderQ10: "",
        programmingHeaderQ11: "",
        programmingHeaderQ12: "",
        programmingHeaderQ13: "",
        programmingHeaderQ14: "",
        programmingHeaderQ15: "",
        userGroup:"",
        masterQuestion1:"",
        masterQuestion2:"",
        masterQuestion3:"",

        // episodeList: [],
        // trackEpisodes: []
        selectedMasterFormId: "",

        newsProgrammeType: "",
        contractArrangement: "",
        commissionTitle: "",
        commissioningNumber:"",
        commissioningChannel: "",
        delivery: "",
        plannedShoot: "",
        plannedDeliver: "",
        plannedTX: "",
        commissioningEditorDetails: "",
        programmingHeaderQ16: "",
        episodeCount: "",
        sportsHeaderQ1: null,
      }
);